import { Line } from 'react-chartjs-2'

import {
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

export const MULTI_LINE_COLORS = ['#1592d1', '#0A8E7C', '#B27700', '#E5004C', '#5000BF']

const buildOptions = (unit: string): ChartOptions<'line'> => ({
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false
  },
  plugins: {
    legend: {
      display: true,
      position: 'top',
      align: 'end',
      labels: {
        color: '#34414F',
        font: { size: 12 },
        boxWidth: 24,
        boxHeight: 2,
        padding: 8,
        usePointStyle: false
      }
    },
    tooltip: {
      backgroundColor: 'rgba(2, 6, 23, 0.95)',
      titleFont: { family: "'JetBrains Mono', monospace", size: 11, weight: 'bold' },
      bodyFont: { family: "'JetBrains Mono', monospace", size: 11 },
      padding: 8,
      cornerRadius: 4,
      borderColor: 'rgba(6,182,212,0.2)',
      borderWidth: 1,
      displayColors: true,
      callbacks: {
        label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y}${unit}`
      }
    }
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: { font: { size: 10 }, color: '#34414F', maxRotation: 0 }
    },
    y: {
      beginAtZero: true,
      border: { display: false },
      grid: { color: '#E4E8EE' },
      ticks: {
        font: { size: 10 },
        color: '#34414F',
        padding: 6,
        count: 6,
        callback: (value) => `${value}${unit}`
      }
    }
  },
  elements: {
    line: { borderWidth: 2.5, tension: 0 },
    point: { radius: 0, hoverRadius: 4, hitRadius: 8 }
  }
})

interface Props {
  labels: string[]
  items: {
    title: string
    values: (number | null)[]
  }[]
  unit?: string
}

const MultiLineChart = ({ labels, items, unit = '' }: Props) => {
  return (
    <Line
      data={{
        labels,
        datasets: items.map((item, i) => ({
          label: item.title,
          data: item.values,
          borderColor: MULTI_LINE_COLORS[i % MULTI_LINE_COLORS.length],
          backgroundColor: MULTI_LINE_COLORS[i % MULTI_LINE_COLORS.length],
          fill: false,
          spanGaps: true
        }))
      }}
      options={buildOptions(unit)}
    />
  )
}

export default MultiLineChart
